import React from "react"
import { standard, light } from "./Paragraph.module.scss"

export const Paragraph = ({ children, type = "standard" }) => {
  const style = type === "standard" ? standard : light
  return <p className={style}>{children}</p>
}
